import { equals } from 'ramda';
import { IOfferState } from '../../redux/reducers';
import { TDynamicPricingAttributes } from '../../types/dynamicPricing';
import { getDynamicPricingParameters } from './getDynamicPricingParameters';

interface IParams {
  offer: IOfferState;
  prevOffer: IOfferState;
  dynamicPricingAttributes: TDynamicPricingAttributes;
}

export const getIsDynamicPricingParametersUpdated = (params: IParams): boolean => {
  const { offer, prevOffer, dynamicPricingAttributes } = params;

  const extraData = getDynamicPricingParameters({ offer, dynamicPricingAttributes });
  const prevExtraData = getDynamicPricingParameters({ offer: prevOffer, dynamicPricingAttributes });

  return !equals(extraData, prevExtraData);
};
